import React from "react";
import "./Button.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const RawButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
  return (
    <button {...rest} className={`raw-button ${rest.className || ""}`}>
      {children}
    </button>
  );
};

/**
 * A reusable button component.
 *
 * @param {React.PropsWithChildren<ButtonProps>} props - Props including children and other HTML attributes for a button.
 * @returns {JSX.Element} The rendered button element.
 */
